import {
	IListNotificationsSet,
	INotificationPayload,
} from '@modules/notification-management/interfaces/notifications.interface';
import { NotificationsService } from '@modules/notification-management/services/notifications.service';
import { ISlackChannelsResponse } from '@core/services/integrations/integrations.interface';
import { IntegrationService } from '@core/services/integrations/integration.service';
import { skipWhile } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class NotificationSetModalService {
	public readonly isUpdating$: Observable<boolean> = this.notificationsService.isUpdatingModal$();

	constructor(private integrationsService: IntegrationService, private notificationsService: NotificationsService) {}

	public hasSlack(): Observable<boolean> {
		return this.integrationsService.hasSlack();
	}

	public hasTeams(): Observable<boolean> {
		return this.integrationsService.hasTeams();
	}

	public create(payload: INotificationPayload): Observable<IListNotificationsSet> {
		return this.notificationsService.createNotificationEntity(payload);
	}

	public getSlackChannels(): Observable<ISlackChannelsResponse> {
		return this.notificationsService.getSlackChannels().pipe(skipWhile((response) => !response.message));
	}

	public getSetNames(): string[] {
		return this.notificationsService.getNotificationSetsValue().map((data) => data.name);
	}
}
